<template>
  <section class="ppt-tool-step">
    <div class="ppt-tool-step__container">
      <Text color="t1" variant="32" class="ppt-tool-step__title">
        不止于观看，实现深度互动与理解
      </Text>
      <div class="ppt-tool-step_list">
        <article v-for="(item, index) in steps" :key="index" class="ppt-tool-step__item">
          <div class="ppt-tool-step__item-title">
            <Text color="t1" variant="16"> 第{{ index + 1 }}步</Text>
            <Text color="t5" variant="16" class="ppt-tool-step__item-title-index">
              {{ item.title }}
            </Text>
          </div>
          <div class="ppt-tool-step__item-content">
            <Img :src="item.url" alt="" />
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { Img } from '@rendora/design/components/img/index';
import { Text } from '@rendora/design/components/text/index';

const steps = [
  {
    title: '上传PDF/PPT文件',
    url: isChinese()
      ? transformImage(getFeUrl('/youyan-platform/ppt-or-pdf/step-1-v3.png'))
      : transformImage(getFeUrl('/rendora/ppt-or-pdf/step-1.png')),
  },
  {
    title: '选择人物形象、声音风格、视频背景',
    url: isChinese()
      ? transformImage(getFeUrl('/youyan-platform/ppt-or-pdf/step-2.png'))
      : transformImage(getFeUrl('/rendora/ppt-or-pdf/step-2.png')),
  },
  {
    title: '输入演讲口播文案并生成视频',
    url: isChinese()
      ? transformImage(getFeUrl('/youyan-platform/ppt-or-pdf/step-3.png'))
      : transformImage(getFeUrl('/rendora/ppt-or-pdf/step-3.png')),
  },
];
</script>

<style scoped lang="scss">
.ppt-tool-step {
  border-bottom: 1px solid var(--back-4);
  padding-bottom: 100px;
}
.ppt-tool-step__container {
  text-align: center;
  max-width: 1200px;
  margin: 0 auto;
}

.ppt-tool-step_list {
  display: flex;
  justify-content: center;
  gap: 33px;
  margin-top: 32px;
}
.ppt-tool-step__item {
  border: 1px solid var(--back-4);
  border-radius: 12px;
  padding: 24px;
  flex: 1 1 0%;
}
.ppt-tool-step__item-title {
  display: flex;
  align-items: center;
}
.ppt-tool-step__item-content {
  border-radius: 12px;
  overflow: hidden;
  width: 331px;
  height: 248px;
  margin-top: 24px;
}

.ppt-tool-step__item-title-index {
  position: relative;
  padding-left: 10px;
}
.ppt-tool-step__item-title-index::before {
  content: '';
  width: 3px;
  height: 3px;
  border-radius: 50%;
  position: absolute;
  background-color: var(--x-text-5);
  left: 3px;
  top: 50%;
  transform: translateY(-50%);
}
@media (max-width: $media-mobile) {
  .ppt-tool-step_list {
    flex-wrap: wrap;
  }
}
</style>
